import { useQueryClient } from 'react-query';

import { usePost } from '../../utils/reactQuery';
import { ApiRoutesEnum } from '../../utils/routes';

export const useUpdateClientEmployee = () => {
  const queryClient = useQueryClient();
  const invalidateRegExp = /\/clients\/.*\/employees/g;
  return usePost({
    url: ApiRoutesEnum.updateClientEmployee,
    onSuccess: () => {
      queryClient.invalidateQueries({
        predicate: (query) =>
          typeof query.queryKey[0] === 'string' && query.queryKey[0].match(invalidateRegExp) !== null,
      });
    },
  });
};
